// 顧客一覧画面
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from '@material-ui/core';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import './List.css';

import GetAppIcon from '@material-ui/icons/GetApp';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { CSVLink } from 'react-csv';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  deleteCustomers,
  getCustomerAssignedUsers,
  getCustomerList,
  getCustomerRank,
  getExportCustomerItems
} from '../apicalls/getCustomerDetails';
import LoadingComponent from '../components/LoadingComponent';
import PaginationComponent from '../components/PaginationComponent';
import {
  assignedUsersRecoilData,
  btnColor,
  customerData,
  customerRankRecoilData,
  isLoggedIn,
  mainBlueColor,
  customerExtInfoKey
} from '../GlobalState';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { TParams } from '../types/CustomerList';
import {
  TExtInfoData,
  TExtInfo,
  TAddInfoData,
  TColumn
} from '../types/ExtInfoBox';
import { TCheckListOption } from '../types/common';
import _ from 'lodash';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { useTheme } from '@mui/material/styles';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const CustomerList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'scroll'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        paddingTop: 30,
        paddingBottom: 30,
        marginTop: 30,
        marginBottom: 30
      },

      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        padding: 8,
        fontWeight: 'bold',
        fontSize: 16
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {
        padding: 8
      }
    })
  );

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();
  const history: any = useHistory();

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);

  const [assignedUsersApiData, setAssignedUsersApiData] = useRecoilState(
    assignedUsersRecoilData
  );
  const changeAssignedUsersApiData = useCallback(
    (newData: any) => setAssignedUsersApiData(newData),
    [setAssignedUsersApiData]
  );

  const [customerApiData, setCustomerApiData] = useRecoilState(customerData);
  const [customerExtInfoRecoilState, setCustomerExtInfoRecoilState] =
    useRecoilState<TExtInfo | undefined>(customerExtInfoKey);

  const changeCustomerApiData = useCallback(
    (newData: any) => setCustomerApiData(newData),
    [setCustomerApiData]
  );

  const [apiData, setApiData] = useState<any>(
    customerApiData !== null ? customerApiData : []
  );
  const [assignedUsers, setAssignedUsers] = useState<any>(
    assignedUsersApiData !== null ? assignedUsersApiData : []
  );
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(
    customerApiData !== null && customerExtInfoRecoilState ? false : true
  );

  const [selectedAssignedUser, setSelectedAssignedUser] = useState<number>(0);
  const [selectedCustomerName, setSelectedCustomerName] = useState('');

  const [customerIds, setCustomerIds] = useState<State>({ arr: [] });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);

  const [myCheckExport, setMyCheckExport] = useState<any>([]);

  const [customerRankApiData, setCustomerRankApiData] = useRecoilState(
    customerRankRecoilData
  );

  const [params, setParams] = useState<TParams>();

  const [transitionFlg, setTransitionFlg] = useState(
    history.location.state ? true : false
  );

  // MEMO: ランクIDの対応
  /*
  0: ランクなし
  1: A
  2: B
  3: C
  */
  const [selectedRankId, setSelectedRankId] = useState(0);

  const [customerRankData, setCustomerRankData] = useState<any>(
    customerRankApiData !== null ? customerRankApiData : []
  );

  const changeCustomerRankApiData = useCallback(
    (newData: any) => setCustomerRankApiData(newData),
    [setCustomerRankApiData]
  );

  const [openModal, setOpenModal] = useState(false);
  const [prefecture, setPrefecture] = useState<string>('');
  const [address, setAddress] = useState<string>('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [displayLimit, setDisplayLimit] = useState<number>(10);

  const [count, setCount] = useState(0);
  const [transactionData, setTransactionData] = useState<any>([]);
  const csvLink: any = useRef();
  const [extInfo, setExtInfo] = useState<TExtInfo>(
    customerExtInfoRecoilState
      ? customerExtInfoRecoilState
      : { columns: [], datas: [] }
  );
  const [addInfoData, setAddInfoData] = useState<TAddInfoData>();
  const checkListOptions: TCheckListOption[] = [
    { name: '顧客名' },
    { furigana: 'ふりがな' },
    { postal_code: '郵便番号' },
    { prefecture: '都道府県' },
    { muncipality: '市区町村' },
    { address: '番地' },
    { building_name: '建物名/部屋番号など' },
    { tel: 'TEL' },
    { fax: 'FAX' },
    { person_in_charge: '顧客側担当者名' },
    { charge_tel: '顧客側担当者電話番号' },
    { in_charge1: '担当者1' },
    { in_charge2: '担当者2' },
    { mediation: '紹介・媒介' },
    { industry: '業種' },
    { end_day: '締日' },
    { deposit_site_date: '入金サイト' },
    { rank: 'ランク' },
    { remarks: '備考' }
  ];
  //{ "charge_name": "顧客側担当者名" },{"prefecture":"都道府県"},{ "building_name": "建物名/部屋番号など" }, { "charge_name": "顧客側担当者名" }, { "charge_tel": "顧客側担当者電話番号" },{" muncipality":"市区町村"},{"tel":"TEL"},{"fax":"FAX"},{"in_charge1":"担当者1"},{"in_charge2":"担当者2"},{"mediation":"紹介・媒介"},{"Industry":"業種"},{"end_day":"締"},{"deposit_site_date":"入金サイト"},{"rank":"ランク"},{"remarks":"備考"} ,{ "street_address": "住所" },

  // 追加情報がある場合は、追加情報のキーとアイテムをcheckListOptionsに追加
  if (extInfo && extInfo.columns) {
    extInfo.columns.forEach(column => {
      let newOption: TCheckListOption = {};
      newOption[column.key] = column.item;
      checkListOptions.push(newOption);
    });
  }

  // 追加情報のチェックボックスを解除された場合は保存されたエクスポート項目から削除
  const setSelectedExportColumns = (
    columns: string[],
    extColumns?: TCheckListOption[]
  ) => {
    if (extColumns && extColumns.length > 0) {
      // extInfoのキーだけ取り出す
      const extInfoKeys = extColumns.map(column => column.key);
      columns = columns.filter(column => {
        // "data_" で始まる要素の場合、extInfoKeys に存在するかチェック
        if (column.startsWith('data_')) {
          return extInfoKeys.includes(column);
        }
        // "data_" で始まらない要素はそのまま保持
        return true;
      });
    }
    setMyCheckExport(columns);
  };

  const handleChange2 = (event: any) => {
    setSelectedAssignedUser(parseInt(event.target.value));
    setParams(prevParams => ({
      ...prevParams,
      selectedAssignedUser: event.target.value
    }));
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const getUsers = useCallback(() => {
    getCustomerAssignedUsers().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setAssignedUsers(data.data);
            changeAssignedUsersApiData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, changeAssignedUsersApiData]);

  const getListOfCustomers = useCallback(
    (addInfoData?: TAddInfoData) => {
      let paramDatas = {
        selectedAssignedUser: selectedAssignedUser,
        selectedCustomerName: selectedCustomerName,
        prefecture: prefecture.trim(),
        address: address,
        currentPage: currentPage,
        displayLimit: displayLimit,
        selectedRankId: selectedRankId
      };

      if (transitionFlg) {
        const params: TParams | undefined = history.location.state.params;
        if (params) {
          paramDatas = {
            selectedAssignedUser: params.selectedAssignedUser
              ? params.selectedAssignedUser
              : 0, // 担当者設定
            selectedCustomerName: params.selectedCustomerName
              ? params.selectedCustomerName
              : '', // 名前設定
            prefecture: params.prefecture ? params.prefecture.trim() : '', // 都道府県設定
            address: params.address ? params.address : '', // 市区町村・番地など設定
            selectedRankId: params.selectedRankId ? params.selectedRankId : 0, // ランク設定
            currentPage: 1,
            displayLimit: 10
          };
        }
      }

      getCustomerList(
        paramDatas.selectedAssignedUser,
        paramDatas.selectedCustomerName,
        paramDatas.prefecture,
        paramDatas.address,
        paramDatas.currentPage,
        paramDatas.displayLimit,
        paramDatas.selectedRankId,
        addInfoData
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              changeCustomerApiData(data.data);
              setApiData(data.data);
              setCount(data.data.length);
              setLoading(false);
              setCustomerIds({ arr: [] });
              setChecked({ check: [] });
              setSelection(false);
              setPageCount(data.page_count);
              setSelectedExportColumns(
                data.selected_columns,
                data.ext_info?.columns
              );
              setExtInfo(data.ext_info);
              setCustomerExtInfoRecoilState(data.ext_info);
            }
          }
        }
      });
    },
    [
      selectedAssignedUser,
      selectedCustomerName,
      prefecture,
      address,
      currentPage,
      displayLimit,
      selectedRankId,
      changeLoggedInData,
      changeCustomerApiData
    ]
  );

  const getAllCustomerRank = useCallback(() => {
    getCustomerRank().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeCustomerRankApiData(data.data);
            setCustomerRankData(data.data);
          }
        }
      }
    });
  }, [changeCustomerRankApiData, changeLoggedInData]);

  useEffect(() => {
    // 画面遷移の際のステートがなければ処理しない
    if (!history.location.state) return;

    // パラメーター取得
    const params: TParams | undefined = history.location.state.params;
    setParams(params);

    if (params) {
      setSelectedAssignedUser(
        params.selectedAssignedUser ? params.selectedAssignedUser : 0
      ); // 担当者設定
      setSelectedCustomerName(
        params.selectedCustomerName ? params.selectedCustomerName : ''
      ); // 名前設定
      setPrefecture(params.prefecture ? params.prefecture : ''); // 都道府県設定
      setSelectedRankId(params.selectedRankId ? params.selectedRankId : 0); // ランク設定
      setTransitionFlg(false); // 画面遷移フラグ
    }
  }, []);

  useEffect(() => {
    getUsers();
    getAllCustomerRank();
  }, [getAllCustomerRank, getUsers]);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedAssignedUser,
    selectedCustomerName,
    selectedRankId,
    prefecture,
    address
  ]);

  useEffect(() => {
    getListOfCustomers(addInfoData);
  }, [
    selectedAssignedUser,
    selectedCustomerName,
    prefecture,
    currentPage,
    displayLimit,
    getListOfCustomers
  ]);

  const deleteSelectedCustomers = () => {
    deleteCustomers(customerIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfCustomers(addInfoData);
          }
        }
      }
    });
  };

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      let subjectArray: any = [];
      setCustomerIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setCustomerIds({ arr: subjectArray });
    } else {
      // subject ids
      setCustomerIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleExport = () => {
    getExportCustomerItems(
      myCheckExport,
      selectedAssignedUser,
      selectedCustomerName,
      prefecture.trim(),
      address,
      selectedRankId,
      addInfoData
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTransactionData(data.rows_list);
            csvLink.current.link.click();
            handleCloseModal();
          }
        }
      }
    });
  };

  const addFildOnChange = (value: any, column: TColumn) => {
    let copyAddInfoData = _.cloneDeep(addInfoData);
    if (!copyAddInfoData) {
      copyAddInfoData = {};
    }

    if (value) {
      copyAddInfoData[column.key] = value;
    } else {
      if (copyAddInfoData[column.key]) {
        if (Object.keys(copyAddInfoData).length > 1) {
          delete copyAddInfoData[column.key];
        } else {
          copyAddInfoData = undefined;
        }
      }
    }
    setAddInfoData(copyAddInfoData);
  };

  /**
   * 追加情報の行を追加
   * @param row
   * @returns
   */
  const addRow = (row: any) => {
    const extInfoData: TExtInfoData | undefined = extInfo?.datas.find(
      item => item.client_id == row.id
    );
    return (
      <>
        {extInfo?.columns &&
          extInfo?.columns.length > 0 &&
          extInfo?.columns.map(column => {
            return (
              <StyledTableCell
                className={classes.table1}
                style={{ minWidth: 100 }}
                align='center'
                onClick={() => {
                  history.push(`/customers/${row.id}/edit`, {
                    state: row.id
                  });
                }}
              >
                {extInfoData ? extInfoData[column.key] : ''}
              </StyledTableCell>
            );
          })}
      </>
    );
  };

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDownScreen = useMediaQuery(theme.breakpoints.up('md'));

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }
  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='customers' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div className={matches2 ? 'main-container-customer' : ''}>
            <div
              className={
                matches2
                  ? 'top-Container-customer'
                  : 'top-Container-customer-responsive'
              }
              style={{ gap: 10, paddingLeft: 0 }}
            >
              <div
                style={{
                  marginBottom: !matches2 ? 10 : 0,
                  height: 35
                }}
                className='select-div'
              >
                <div>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={selectedAssignedUser}
                      onChange={handleChange2}
                      style={{ paddingLeft: 5 }}
                      name='age'
                      inputProps={{ 'aria-label': 'age' }}
                      disableUnderline
                    >
                      <option value={0}>担当者</option>
                      {assignedUsers.length > 0 &&
                        getUserSelectOptions(assignedUsers)}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>
              <input
                value={selectedCustomerName}
                maxLength={30}
                style={{
                  marginLeft: matches2 ? 20 : 0,
                  marginBottom: !matches2 ? 10 : 0,
                  backgroundColor: '#FFFFFF'
                }}
                className={classes.formControl1}
                onChange={text => {
                  setSelectedCustomerName(text.target.value);
                  setParams(prevParams => ({
                    ...prevParams,
                    selectedCustomerName: text.target.value
                  }));
                }}
                placeholder='顧客名'
              />
              <div>
                <input
                  value={prefecture}
                  maxLength={5}
                  type='string'
                  onChange={e => {
                    setPrefecture(e.target.value);
                    setParams(prevParams => ({
                      ...prevParams,
                      prefecture: e.target.value
                    }));
                  }}
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    marginBottom: !matches2 ? 10 : 0,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='都道府県'
                />
              </div>
              <div>
                <input
                  value={address}
                  maxLength={120}
                  type='string'
                  onChange={e => {
                    setAddress(e.target.value);
                    setParams(prevParams => ({
                      ...prevParams,
                      address: e.target.value
                    }));
                  }}
                  style={{
                    marginLeft: matches2 ? 20 : 0,
                    marginBottom: !matches2 ? 10 : 0,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='市区町村・番地など'
                />
              </div>
              <div
                style={{
                  marginLeft: matches2 ? 20 : 0,
                  marginBottom: !matches2 ? 10 : 0,
                  height: 35
                }}
                className='select-div'
              >
                <div>
                  <FormControl className={classes.formControl}>
                    <BasicSelect
                      value={selectedRankId}
                      onChange={(e: any) => {
                        setSelectedRankId(e.target.value);
                        setParams(prevParams => ({
                          ...prevParams,
                          selectedRankId: e.target.value
                        }));
                      }}
                      style={{ paddingLeft: 5 }}
                      inputProps={{ 'aria-label': 'rank' }}
                      disableUnderline
                    >
                      <option value={0}>ランク</option>
                      {customerRankData.map((i: any) => (
                        <option value={i.id}>{i.name}</option>
                      ))}
                    </BasicSelect>
                  </FormControl>
                </div>
              </div>

              {extInfo?.columns &&
                extInfo?.columns.length > 0 &&
                extInfo?.columns.map((column, index) => {
                  return (
                    <div key={index}>
                      <input
                        // value={prefecture}
                        maxLength={225}
                        onChange={e => {
                          addFildOnChange(e.target.value, column);
                        }}
                        style={{
                          margin: '0px 10px',
                          backgroundColor: '#FFFFFF'
                        }}
                        className={classes.formControl1}
                        placeholder={column.item}
                      />
                    </div>
                  );
                })}

              <Button
                style={{
                  marginLeft: matches2 ? 20 : 0,
                  marginBottom: !matches2 ? 10 : 0,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
                onClick={() => {
                  setCurrentPage(1);
                  getListOfCustomers(addInfoData);
                }}
              >
                検索
              </Button>
            </div>
          </div>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div
              className='table-top-container-customer'
              style={{
                display: 'flex',
                flexDirection: isSmDownScreen ? 'row' : 'column'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: isSmDownScreen ? '20%' : '100%'
                }}
              >
                <div style={{ fontWeight: 'bold' }}>顧客一覧</div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: isSmDownScreen ? 'row' : 'column'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: isSmDownScreen ? 'center' : 'end'
                  }}
                >
                  <div
                    style={{ marginRight: 10, paddingLeft: 5, marginBottom: 5 }}
                    className='select-div'
                  >
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={displayLimit}
                        onChange={e => {
                          setCurrentPage(1);
                          setDisplayLimit(parseInt(e.target.value));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={10}>10件</option>
                        <option value={30}>30件</option>
                        <option value={50}>50件</option>
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
                <div>
                  {/* 新規作成ボタン */}
                  {isSmDownScreen ? (
                    <>
                      <Button
                        style={{
                          backgroundColor: buttonColor,
                          marginRight: 10,
                          marginBottom: !matches2 ? 10 : 0
                        }}
                        variant='contained'
                        color='secondary'
                        startIcon={<NoteAddIcon />}
                        onClick={() => {
                          history.push('/customers/create', {
                            params: params
                          });
                        }}
                      >
                        新規作成
                      </Button>
                      <CustomTooltip
                        title={tooltipContents.customersSelectDelete}
                        placement='top'
                      >
                        <Button
                          style={{
                            backgroundColor: buttonColor,
                            marginRight: 10,
                            marginBottom: !matches2 ? 10 : 0
                          }}
                          variant='contained'
                          color='secondary'
                          startIcon={<DeleteIcon />}
                          onClick={() => {
                            if (customerIds.arr.length <= 0) {
                              alert('対象を選択してください。');
                            } else {
                              handleClickOpenAlert();
                            }
                          }}
                        >
                          選択削除
                        </Button>
                      </CustomTooltip>
                      <CustomTooltip
                        title={tooltipContents.customerList}
                        placement='top'
                      >
                        <Button
                          style={{
                            backgroundColor: buttonColor,
                            marginBottom: !matches2 ? 10 : 0
                          }}
                          onClick={handleOpenModal}
                          variant='contained'
                          color='secondary'
                          startIcon={<GetAppIcon />}
                        >
                          エクスポート
                        </Button>
                      </CustomTooltip>
                    </>
                  ) : (
                    <>
                      <Button
                        style={{
                          backgroundColor: buttonColor,
                          marginRight: 8,
                          marginBottom: !matches2 ? 10 : 0
                        }}
                        variant='contained'
                        color='secondary'
                        onClick={() => {
                          history.push('/customers/create', {
                            params: params
                          });
                        }}
                      >
                        新規作成
                      </Button>
                      <CustomTooltip
                        title={tooltipContents.customersSelectDelete}
                        placement='top'
                      >
                        <Button
                          style={{
                            backgroundColor: buttonColor,
                            marginRight: 8,
                            marginBottom: !matches2 ? 10 : 0
                          }}
                          variant='contained'
                          color='secondary'
                          onClick={() => {
                            if (customerIds.arr.length <= 0) {
                              alert('対象を選択してください。');
                            } else {
                              handleClickOpenAlert();
                            }
                          }}
                        >
                          選択削除
                        </Button>
                      </CustomTooltip>
                      <CustomTooltip
                        title={tooltipContents.customerList}
                        placement='top'
                      >
                        <Button
                          style={{
                            backgroundColor: buttonColor,
                            marginBottom: !matches2 ? 10 : 0
                          }}
                          onClick={handleOpenModal}
                          variant='contained'
                          color='secondary'
                        >
                          エクスポート
                        </Button>
                      </CustomTooltip>
                    </>
                  )}
                </div>
              </div>
            </div>

            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby='max-width-dialog-title'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <div>
                    <div
                      className='border1'
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <div style={{ flex: 3 }}>
                        <div
                          style={{ padding: 10, backgroundColor: mainColor }}
                        >
                          <div style={{ color: '#FFFFFF' }}>エクスポート</div>
                        </div>
                      </div>
                    </div>

                    {checkListOptions.map((i: any, index) => {
                      return (
                        <div
                          className='border1'
                          style={{ display: 'flex', flexDirection: 'row' }}
                        >
                          <div
                            style={{
                              flex: 3,
                              backgroundColor:
                                index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                            }}
                          >
                            <div style={{ padding: 3 }}>
                              <Checkbox
                                name='expertCheckbox'
                                checked={
                                  myCheckExport.includes(
                                    Object.keys(i).toString()
                                  )
                                    ? true
                                    : false
                                }
                                onClick={e => {
                                  var ind = myCheckExport.indexOf(
                                    Object.keys(i).toString()
                                  );
                                  if (ind === -1) {
                                    setMyCheckExport([
                                      ...myCheckExport,
                                      Object.keys(i).toString()
                                    ]);
                                  } else {
                                    setMyCheckExport(
                                      myCheckExport.filter(
                                        (char: any, aa: any) => aa !== ind
                                      )
                                    );
                                  }
                                }}
                                style={{
                                  color: myCheckExport.includes(
                                    Object.keys(i).toString()
                                  )
                                    ? buttonColor
                                    : '#758283'
                                }}
                              />
                              {Object.values(i)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div></div>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  style={{ backgroundColor: buttonColor }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    handleExport();
                  }}
                  startIcon={<GetAppIcon />}
                >
                  保存
                </Button>
                <CSVLink
                  data={transactionData}
                  filename='顧客一覧.csv'
                  className='hidden'
                  ref={csvLink}
                  target='_blank'
                />
              </div>
            </Dialog>

            <Dialog
              open={openAlert}
              onClose={handleCloseAlert}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'選択した顧客を削除しますか？'}
              </DialogTitle>
              {/* <DialogContent>
              <DialogContentText id="alert-dialog-description">
                削除しますか？
          </DialogContentText>
            </DialogContent> */}
              <DialogActions>
                <Button onClick={handleCloseAlert} color='primary'>
                  キャンセル
                </Button>
                <Button
                  onClick={() => {
                    deleteSelectedCustomers();
                  }}
                  color='primary'
                  autoFocus
                >
                  削除
                </Button>
              </DialogActions>
            </Dialog>

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      <CustomTooltip
                        title={tooltipContents.selectDelete}
                        placement='top'
                      >
                        <Checkbox
                          checked={isSelected}
                          onClick={() => {
                            setSelection(!isSelected);
                            selectAllCheckBoxPressed();
                          }}
                          style={{
                            color: isSelected ? buttonColor : '#FFFFFF'
                          }}
                        />
                      </CustomTooltip>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      顧客名
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      ふりがな
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      住所
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      担当者
                    </StyledTableCell>
                    {/* <StyledTableCell
                      className={classes.table}
                      align="center"
                    ></StyledTableCell> */}
                    {extInfo?.columns &&
                      extInfo?.columns.length > 0 &&
                      extInfo?.columns.map((column, index) => {
                        return (
                          <StyledTableCell
                            style={{ minWidth: 100 }}
                            className={classes.table}
                            align='center'
                            key={index}
                          >
                            {column.item}
                          </StyledTableCell>
                        );
                      })}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow
                      key={row.id}
                      className='click_table_row'
                      title='編集'
                      // onClick={() => {
                      //   history.push(`/customers/${row.id}/edit`, {
                      //     state: row.id,
                      //   });
                      // }}
                    >
                      <StyledTableCell
                        className={classes.table1}
                        align='center'
                      >
                        <CustomTooltip
                          title={tooltipContents.selectDelete}
                          placement='top'
                        >
                          <Checkbox
                            checked={checked.check[index] ? true : false}
                            onClick={() => {
                              handleChange(index);
                              let newArr = customerIds.arr;
                              if (!checked.check[index] && !pressed[index]) {
                                newArr.push(row.id);
                                setCustomerIds({ arr: newArr });
                              } else {
                                var ind = customerIds.arr.indexOf(row.id);
                                if (ind !== -1) customerIds.arr.splice(ind, 1);
                              }
                              setCheckBoxSelected(!checkBoxSelected);
                            }}
                            style={{
                              color: checked.check[index]
                                ? buttonColor
                                : '#758283'
                            }}
                          />
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/customers/${row.id}/edit`, {
                            state: row.id,
                            params: params
                          });
                        }}
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 130 }}
                        align='center'
                        onClick={() => {
                          history.push(`/customers/${row.id}/edit`, {
                            state: row.id,
                            params: params
                          });
                        }}
                      >
                        {row.furigana}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/customers/${row.id}/edit`, {
                            state: row.id,
                            params: params
                          });
                        }}
                      >
                        {row.street_address}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 80 }}
                        align='center'
                        onClick={() => {
                          history.push(`/customers/${row.id}/edit`, {
                            state: row.id,
                            params: params
                          });
                        }}
                      >
                        {row.person_in_charge}
                      </StyledTableCell>
                      {/* <StyledTableCell
                        className={classes.table1}
                        align="center"
                      >
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            history.push(`/customers/${row.id}/edit`, {
                              state: row.id,
                            });
                          }}
                        >
                          編集
                        </Button>
                      </StyledTableCell> */}
                      {addRow(row)}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
            <PaginationComponent
              page={currentPage}
              pageCount={pageCount}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
